import{ React, useState, useEffect, LoaderOverlay, withAuth, toast,connect, useDispatch, useSelector,useNavigate,useLocation, MESSAGES } from './../../common/helper/common-imports.component.js';
import{  RowsPerPageSelector, SearchTable, DataTable,customDataTableStyles } from './../../common/helper/table-imports.js';

import CryptoService from "../../../services/crypto-service.js";
import { cryptoListColumnsAgents,cryptoColumnsMerchants } from './crypto-list-col.component.js'
function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const CryptoList = () => { 
  const [loading, setLoading] = useState(false);
  const [expanded, setExpanded] = useState({});
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [dataTableKey, setDataTableKey] = useState(0);
  const [searchTerm, setSearchTerm] = useState('');
  const dispatch = useDispatch();
  const query = useQuery();
  let paramValue = query.get('userType');
  const [crypto, setCrypto] = useState([]);
  const [tab,setTab] = useState('agent');
  
  const [columnsAgents,setAgents] = useState(cryptoListColumnsAgents());
  const [columnsMerchants,setMerchants] = useState(cryptoColumnsMerchants());

  const getCryptoList = (userType) => {
    setLoading(true);
    CryptoService.getCrypto(userType)
      .then(response => {
        setCrypto(response.data.data.list)
   
        setLoading(false);
      })
      .catch(error => {
        setLoading(false);
        console.error("Error fetching agents:", error);
      });
   
  }
  useEffect(() => {
   
    if(paramValue == 'agent') {
      getCryptoList('AGENT');
    } else if(paramValue == 'merchant') {
      getCryptoList('MERCHANT');
    } else {
      getCryptoList('AGENT');
    }
  
    document.body.style.backgroundImage = '';
    document.body.style.backgroundColor = '#f0f6fa';
    
    return () => {
      document.body.style.backgroundColor = '';
    };
  }, []);
  const navigate = useNavigate();


  const handleRowsPerPageChange = (value) => {
    setRowsPerPage(Number(value));
    setDataTableKey(prevKey => prevKey + 1);
  };

const paginationComponentOptions = { 
  noRowsPerPage :true
}
const handleSearchChange = (e) => {
  setSearchTerm(e.target.value);
};

const escapeRegExp = (string) => {
  return string.replace(/[.*+\-?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
};
const filteredData = crypto.filter((row) =>
Object.values(row).some(
  (value) =>
    new RegExp(escapeRegExp(searchTerm), 'i').test(value)
)
  );


const resetSearch = (tab) => {
  setTab(tab)
  if(tab == 'agent') {
    getCryptoList('AGENT');
  } else if(tab == 'merchant'){
    getCryptoList('MERCHANT');
  }
  setRowsPerPage(10);
  setSearchTerm('');
}
 useEffect(() => {
    if (filteredData?.length) {
      const element = document.getElementsByClassName("sc-bHCmUC");
      const childElement = element[0].children;
      for (let i = 0; i < childElement?.length; i++) {
        const ele = childElement[i].id.split("-")[1];
        if (Number(ele) % 2 === 0) {
          childElement[i].classList.add("even-transaction-table");
        } else {
          childElement[i].classList.add("odd-transaction-table");
        }
      }
    }
  }, [filteredData]);



  return (
    <div>
            <LoaderOverlay loading={loading} />

    <div className="container-fluid px-4" style={{paddingBottom: '30px'}}>
                    <div className="container" style={{backgroundColor: 'white'}}>
                      <nav>
                        <div className="nav nav-tabs" id="nav-tab" role="tablist" >
                          <button className={`nav-link tbbtn ${paramValue === 'agent' ? 'active' : ''}`} id="nav-home-tab" data-bs-toggle="tab" data-bs-target="#nav-home" type="button" role="tab" aria-controls="nav-home" aria-selected="true" onClick={() => resetSearch('agent')}> Agents </button>
                          <button className={`nav-link tbbtn ${paramValue === 'merchant' ? 'active' : ''}`} id="nav-profile-tab" onClick={() => resetSearch('merchant')} data-bs-toggle="tab" data-bs-target="#nav-profile" type="button" role="tab" aria-controls="nav-profile" aria-selected="false" >Merchants</button>
                        
                        </div>
                      </nav>
    
                      <div className="filterBtn">
                        
                        <div id="examplemgm_filter" className="dataTables_filter"><label><input type="search" className placeholder="Search..."  value={searchTerm}
                        onChange={handleSearchChange} aria-controls="examplemgm" /></label></div>
                        {/* <div className="dt-buttons ui-buttonset"><a className="dt-button ui-button ui-state-default ui-button-text-only btn btn-success ddfg" tabIndex={0} aria-controls="examplemgm"><span className="ui-button-text" onClick={addNewAgent}>Add Agent</span></a></div> */}
                  </div>

                  <RowsPerPageSelector rowsPerPage={rowsPerPage} onRowsPerPageChange={handleRowsPerPageChange} />
                      <div className="tab-content" id="nav-tabContent" style={{paddingTop: '15px'}}>
                        <div   className={`tab-pane fade ${paramValue === 'agent' ? 'show active' : ''}`} id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab" style={{position: 'relative'}}>

                        <div className="multi">
                          <span className="DataTables_sort_icon css_right ui-icon ui-icon-triangle-1-n" /></div>

                        <DataTable key={dataTableKey}
                            columns={columnsAgents}
                              data={filteredData}
                              pagination
                              
                             customStyles={customDataTableStyles}
                              
                             
                              
                              paginationComponentOptions={paginationComponentOptions} 
                             
                              paginationPerPage={rowsPerPage} 
                             
                            
                              
                        />
                        </div>
                        <div className={`tab-pane fade ${paramValue === 'merchant' ? 'show active' : ''}`} id="nav-profile" role="tabpanel" aria-labelledby="nav-profile-tab">
                        <DataTable key={dataTableKey}
                            columns={columnsMerchants}
                              data={filteredData}
                              pagination
                              
                              customStyles={customDataTableStyles}

                             
                              
                              paginationComponentOptions={paginationComponentOptions} 
                             
                              paginationPerPage={rowsPerPage} 
                            
                              
                        />
                        </div>
                      
                      </div>
                    </div>
                  </div>
                  
                  </div>
               

)

}
function mapStateToProps(state) {
   const userData = state.authReducer.user;
   return { userData };
 }
 export default withAuth(connect(mapStateToProps)(CryptoList));

 
 
